import type React from 'react';

import { CrossCircleIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { toast } from 'react-toastify';

import { useUpdateGroup } from '@vlabs/api/artemy/client';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { useDetachDepartmentGroupsTranslation } from './i18n';
import type { DetachDepartmentGroupsProps } from './types';

type DetachDepartmentGroupsIconButtonProps = DetachDepartmentGroupsProps & Omit<IconButtonProps, 'onClick'>;

const displayName = 'DetachDepartmentGroupsIconButton';
const testid = buildTestid(displayName);

function DetachDepartmentGroupsIconButton({
  groupIds,
  onDetachDepartmentGroups,
  'data-testid': dataTestId = undefined,
  ...props
}: DetachDepartmentGroupsIconButtonProps): React.JSX.Element {
  const { t } = useDetachDepartmentGroupsTranslation();
  const patchGroup = useUpdateGroup();

  const handleClick = async () => {
    try {
      // @ts-expect-error некорректная схема api, шлём owner_department: null
      await Promise.all(groupIds.map(async (groupId) => patchGroup.mutateAsync({ groupId, data: { owner_department: null } })));
      toast.success(t('toast_success'));
      onDetachDepartmentGroups?.();
    } catch {
      toast.error(t('toast_error'));
    }
  };

  return (
    <IconButton
      disabled={props.disabled ?? patchGroup.isPending}
      icon={<CrossCircleIcon />}
      kind="negative"
      onClick={handleClick}
      title={t('title')}
      variant="dimmed"
      {...testid(dataTestId)}
      {...props}
    />
  );
}

DetachDepartmentGroupsIconButton.displayName = displayName;

export { DetachDepartmentGroupsIconButton };
